import { render, staticRenderFns } from "./CounsellorDelete.vue?vue&type=template&id=02f42821&"
import script from "./CounsellorDelete.vue?vue&type=script&lang=js&"
export * from "./CounsellorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports